import React, { useCallback, useContext, useEffect, useRef, useState } from "react";
import { Button, Card, Dropdown, Input, Modal, Tag } from "antd";
import { motion } from "framer-motion";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { RWebShare } from "react-web-share";
import { renderList } from "../../Reducer/globalSlice";
import {
  setInterestAndAssetType, setMicroSiteName, setOrganisationType, setPage, setPartnerId, setSector, setSubSector, setTabValue, updateZoom,
  setSize as localStorageSetSize
  , updateOrganisationNameById, setSearchName as updateSearchName,
  setSubSectorResponse
} from "../../Reducer/localStorageSlice";
import { deleteRequest, getRequest, postRequest } from "../../api/http";
import userapiservice from "../../api/userapiservice";
import lockIcon from '../../assets/images/lockIcon.png';
import shareIcon from "../../assets/images/share-icon.svg";
import share from "../../assets/images/share.svg";
import favorite from "../../assets/newImages/Favorite.svg";
import favoriteActive from "../../assets/newImages/FavoriteActive.svg";
import youTubePlayButton from "../../assets/newImages/Play.svg";
import SynthesiaImage from '../../assets/newImages/synthesia.jpg';
import ytPlayBtn from '../../assets/newImages/Play.svg'
import ListIcon from "../../assets/newImages/list.svg";
import MapIcon from "../../assets/newImages/map.svg";
import { Back, CloseActive, SearchZoomActive } from "../../components/Icons/Icons";
import Loader from "../../components/Loader/Loader";
import ModalPlayer from "../../components/PlayerModal/playerModal";
import ToastComponent from "../../components/ToastCompoent/ToastComponent";
import { GlobalContext } from "../../components/globalContext/GlobalContext";
import { enumAndLabelAdapter, typeOfDevice as findTypeOfDevice } from "../../utils/util";
import MapView from "./MapView";
import "./MicroSites.scss";
import Filter from "./filter";
import { inputFieldCharLimit } from "../../config";
import { getYouTubeVideoId } from "../../utils/helper";
import usePartnerName from "../../hooks/usePartnerName";

export default function MicroSites() {
  const location = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();


  const selectorData = useSelector((state) => state.global);
  const localData = useSelector((state) => state?.localStorage)
  const { formattedName: partner } = usePartnerName()
  const { zoom, partnerId, sector: sectorId, searchName: localDataSearchName,
    size: localDataSize, ['Interest/AssetType']: interestAssetType, subSector: subsectorId, accessToken: localDataAccessToken
    , OrganisationType, organisationNameById: localDataOrganisationById } = localData
  const typeOfDevice = findTypeOfDevice()

  const { setProfileOpen, openMicrosite, setOpenMicrosite } = useContext(GlobalContext);
  const phoneNumber = selectorData?.userProfile?.phoneNumber;
  const accessToken = localDataAccessToken;

  const [loadingForOrgDirData,setLoadingForOrgDirData] = useState(false)
  const [masterDataIds,setMasterDataIds] = useState([])
  const [orgDirectoryData,setOrgDirectoryData] = useState([])

  const sentinelRef = useRef(null)
  const [orgDirPageSize,setOrgDirPageSize] = useState(15)
  const [orgDirPageNumber,setOrgDirPageNumber] = useState(0)
  const isFetchingRef = useRef(false);

  const [selectedMicrosite, setSelectedMicrosite] = useState(null);
  const [microsites, setMicrosites] = useState();
  const [getSector, setGetSector] = useState([]);
  const [loading, setLoading] = useState(true);
  const [updateFilterData, setUpdateFilterData] = useState(false);
  const [allResponse, setAllResponse] = useState([]);
  const [videoUrl, setVideoUrl] = useState("");
  const [mediatype, setmediatype] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [af, setAf] = useState("");
  const [gl, setGl] = useState("");
  const [ms, setMs] = useState("");
  const [tz, setTz] = useState("");
  
  const [boolaf, setBoolAf] = useState(false);
  const [boolgl, setBoolGl] = useState(false);
  const [boolms, setBoolMs] = useState(false);
  const [booltz, setBoolTz] = useState(false);
  const [searchText, setSearchText] = useState('')
  const [showModal, setShowModal] = useState(false)
  const [bookmarkData, setBookmarkData] = useState([]);
  const baseUrl = window.location.origin;
  const [activeMicros, setActiveMicros] = useState("both");
  const [loader, setLoader] = useState(false);
  const [radiusValue, setRadiusValue] = useState();
  const [selectedMicroSite, setSelectedMicroSite] = useState();
  const [allowSetView, setAllowSetView] = useState(false);
  const [favMicroSites, setFavMicroSites] = useState(false);
  const [mapHeight, setMapHeight] = useState()
  const [debouncedSearchText, setDebouncedSearchText] = useState(searchText);
  const [subSectors, setSubSectors] = useState([]);
  const [selectedInterest, setSelectedInterest] = useState(interestAssetType || null);
  const [size, setSize] = useState(localDataSize || null);
  const [interestName, setinterestName] = useState(interestAssetType || null);
  const [searchName, setSearchName] = useState(localDataSearchName || null);

  const [hasMoreOrgDir,setHasMoreOrgDir] = useState(true)
  const [totalData,setTotalData] = useState([])

  const [dontShowOrgData,setDontShowOrgData] = useState(false)

  const [partnerData, setPartnerData] = useState({});
  const { id } = useParams();


  const fetchMasterDataIds = useCallback(async()=>{
    const response = await getRequest(userapiservice.getMasterDataIds())
    if(response?.length){
      setMasterDataIds(response)
    }
  },[])

  const fetchOrgDirectoryData = useCallback(async(partner,searchText)=>{
    if(!partner) return
    if (isFetchingRef.current) return;
    isFetchingRef.current = true;
    setLoadingForOrgDirData(true)
    try{
      const response = await getRequest(userapiservice.getOrgDirectoryData({
        partner,
        searchText,
        pageNumber: orgDirPageNumber
      }))
      if(Array.isArray(response?.result)){
        const totalFetched = orgDirectoryData?.length + response?.result?.length
        
        if(response?.result?.length<orgDirPageSize || totalFetched >= response?.totalCount){
          setHasMoreOrgDir(false)
        }
        else{
          setHasMoreOrgDir(true)
        }
        if(orgDirPageNumber === 0){
          setOrgDirectoryData(response?.result)
        }
        else{
          setOrgDirectoryData((p)=>[...p,...(response?.result || [])])
        }
        
      }
    }catch(err){
      
    }finally{
      setTimeout(() => {
      isFetchingRef.current = false;
    }, 300);
      setLoadingForOrgDirData(false)
    }
    
  },[orgDirPageNumber])

  
  useEffect(()=>{
    const partOne = microsites?.map((m)=>({
      ...m,
      isActual: true
    })) || []
    const partTwo = dontShowOrgData ? [] : orgDirectoryData?.map((o)=>({
      ...o,
      isActual: false
    })) || []
    setTotalData([...partOne,...partTwo])
  },[microsites,orgDirectoryData,dontShowOrgData])

  useEffect(()=>{
    fetchOrgDirectoryData(partner, debouncedSearchText)
  },[partner, fetchOrgDirectoryData, debouncedSearchText, orgDirPageNumber])


useEffect(() => {
  const timer = setTimeout(() => {
    setDebouncedSearchText(searchText);
    setOrgDirPageNumber(0)
  }, 500); // debounce delay

  return () => clearTimeout(timer);
}, [searchText]);

  useEffect(()=>{
    fetchMasterDataIds()
  },[fetchMasterDataIds])

  const onClickGetMicrositeView = async (micrositeId) => {
    try {
      const response = await postRequest(userapiservice.getMicrositeView(micrositeId));
      if (response) {
      }
    } catch (error) {
      toast.error(<ToastComponent type={'Error'} message={error?.response?.data?.message || 'Sorry, Something went wrong'} />)
    }
  };

  const handleCardClick = (microsite) => {
    setSelectedMicrosite(microsite);
    // setProfileOpen(true);
    // navigate(`/microsite${microsite?.id}`)
    // onClickGetMicrositeView(microsite?.id)

    const name = microsite?.name
    const formattedName = name.replace(/ /g, "_");
    dispatch(setMicroSiteName(formattedName))
    navigate(`/microsite/${formattedName}`, {
      state: { page: "home", logo: 'logo' },
    });
  };

  useEffect(() => {
    if (openMicrosite) {
      OnCardClickHandler(
        selectedMicrosite?.id,
        selectedMicrosite?.mediaLink,
        selectedMicrosite?.name
      );
      setOpenMicrosite(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [openMicrosite]);
  useEffect(() => {
    // const zoomValue = zoom;
    const zoomValue = localStorage.getItem("zoom")
    if (!zoomValue) {
      dispatch(updateZoom(6))
      localStorage.setItem("zoom", 6)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (typeOfDevice !== "laptop" && selectorData?.list) {
      setActiveMicros("list");
      dispatch(renderList(false));
    } else if (typeOfDevice !== "laptop") {
      setActiveMicros("view");
    }
    setMapHeight(document.getElementById("list")?.offsetHeight)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [typeOfDevice]);


  const [organisationTypeName, setOrganisationTypeName] = useState(
    OrganisationType || null
  );

  const [selectedOrganisationType, setSelectedOrganisationType] = useState(OrganisationType || null);
  const [organisationNameById, setOrganisationNameById] = useState(localDataOrganisationById || '');

  const fetchSectorList = async () => {
    if (!partnerId) return; // ✅ Run only if partnerId exists
    try {
      const response = await getRequest(
        userapiservice.getAllSectors(partnerId)
      );
      setGetSector(response)
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (partner && partnerId) {
      fetchSectorList();
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [partnerId]);

  useEffect(() => {
    if (activeMicros === "both") {
      setRadiusValue(2);
    }
  }, [activeMicros]);

  const getPartnerDetails = async () => {
    if(!partner) return
    try {
      const response = await getRequest(
        userapiservice.getPartnerDetails(partner)
      );
      if (response) {
        setPartnerData(response);
        dispatch(setPartnerId(response?.id))
      }
    } catch (e) {
      Modal.error({
        title: "Error",
        content: e.response?.data?.message || "Something went wrong...",
      });
    }
  };

  useEffect(() => {
    getPartnerDetails();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [partner]);

  const convertToStandardURL = (shortUrl) => {
    if (shortUrl?.indexOf("youtu.be") !== -1) {
      const video_id = shortUrl?.split("youtu.be/")[1].split("?")[0];
      return `https://www.youtube.com/watch?v=${video_id}`;
    }
    return shortUrl;
  };

  const getBookmark = async (updateToMicroSites = false) => {
    try {
      const response = await getRequest(
        userapiservice.getBookmark(phoneNumber, partner), undefined, false
      );
      if (response) {
        setBookmarkData(response.microsites);
        if (updateToMicroSites) {
          setMicrosites(response?.microsites);
        }
      }
    } catch (error) {
      toast.error(<ToastComponent type={'Error'} message={error?.error || error?.message || 'Sorry, Something went wrong'} />)

    }
  };

  const postBookmark = async (id, name) => {
    try {
      const response = await postRequest(
        userapiservice.postBookmark(id, phoneNumber)
      );
      if (response) {
        toast.success(<ToastComponent type={'Success'} message={`${name} added to favorites`} />)
        getBookmark();
      }
    } catch (error) {
      toast.error(<ToastComponent type={'Error'} message={error?.error || error?.message || 'Sorry, Something went wrong'} />)
    }
  };

  const handleBookmark = (id, name) => {
    postBookmark(id, name);
  };

  useEffect(() => {
    if (phoneNumber && accessToken) {
      getBookmark();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(()=>{
    if(organisationTypeName ||
        organisationNameById ||
        interestName ||
        sectorId ||
        subsectorId ||
        size) {
          setDontShowOrgData(true)
        }
        else{
          setDontShowOrgData(false)
          setOrgDirPageNumber(0)
        }
  },[organisationTypeName, organisationNameById, interestName, sectorId, subsectorId, size])
  
  const fetchMicrosites = async (
    partner,
    organisationTypeName,
    interestName,
    sectorId,
    subsectorId,
    size,
    searchName,
    af,
    gl,
    ms,
    tz
  ) => {
    if(!partner) return
    setLoading(true);
    const searchText = encodeURIComponent(searchName || '');
    try {

      const masterDataValue = enumAndLabelAdapter(interestName)
      const masterDataId = masterDataIds?.find((m)=>m?.value===masterDataValue)?.id
      if(interestName){
        if(!masterDataId) return
      }
      
      await getRequest(
        userapiservice.filterMicrosites(
          partner,
          organisationTypeName,
          interestName,
          sectorId,
          subsectorId,
          size,
          searchText,
          af,
          gl,
          ms,
          tz,
          masterDataId
        )
      ).then((res) => {
        let response = [...res.result];
        let output = [...res.result];
        setAllResponse(response.result);
        setMicrosites([
          ...new Map(output.map((item) => [item["id"], item])).values(),
        ]);

        if (interestName) {

          dispatch(setInterestAndAssetType(interestName || ''))
          if (interestName === "PRODUCT") {
            dispatch(setTabValue('product'))
          } else if (interestName === "SERVICE") {
            dispatch(setTabValue('service'))
          } else if (interestName === "CONTRACTS") {
            dispatch(setTabValue('contract'))

          } else if (interestName === "VACANCY") {
            dispatch(setTabValue('vacancy'))

          } else if (interestName === "APPRENTICESHIP") {
            dispatch(setTabValue('apprenticeship'))

          } else if (interestName === "WORK_EXPERIENCE") {
            dispatch(setTabValue('work-experience'))

          } else if (interestName === "COURSES") {
            dispatch(setTabValue('courses'))

          }
        }

        setLoading(false);
      });
    } catch (e) {
      Modal.error({
        title: "Error",
        content: e.response?.data?.message || "Something went wrong...",
      });
      setLoading(false);
    }
  };

  useEffect(() => {
    if (location.state?.data && location.state?.data.length > 0) {
      setMicrosites(location.state.data);
    } else {
      
      fetchMicrosites(
        partner,
        selectedOrganisationType,
        selectedInterest,
        sectorId,
        subsectorId,
        size,
        debouncedSearchText,
        af,
        gl,
        ms,
        tz
      );
    }
      


    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [af, gl, ms, tz, masterDataIds, debouncedSearchText, partner]);

  useEffect(() => {
    if (favMicroSites) {
      getBookmark(true);
    } else {
      fetchMicrosites(
        partner,
        selectedOrganisationType,
        selectedInterest,
        sectorId,
        subsectorId,
        size,
        searchName,
        af,
        gl,
        ms,
        tz
      );
      setLoading(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [favMicroSites]);

  const OnCardClickHandler = async (id, logo, name) => {
    const formattedName = name.replace(/ /g, "_");
    dispatch(setMicroSiteName(formattedName))
    navigate(`/microsite/${formattedName}`, {
      state: { page: "home", logo: { logo }, microType: "list" },
    });
  };



  const RemoveHandler = (value) => {
    if (value === "organisationType") {
      setOrganisationTypeName(null);
      setSelectedOrganisationType(null);
      dispatch(setOrganisationType(''))
      dispatch(updateOrganisationNameById(''))

      fetchMicrosites(
        partner,
        null,
        interestName,
        sectorId,
        subsectorId,
        size,
        debouncedSearchText,
        af,
        gl,
        ms,
        tz
      );
    }
    if (value == "interest") {
      dispatch(setInterestAndAssetType(''))
      dispatch(setTabValue(''))

      setinterestName(null);
      setSelectedInterest(null);
      fetchMicrosites(
        partner,
        organisationTypeName,
        null,
        sectorId,
        subsectorId,
        size,
        debouncedSearchText,
        af,
        gl,
        ms,
        tz
      );
    }
    if (value == "sector") {
      dispatch(setSector(""))
      dispatch(setSubSector(""))
      setSubSectors(null);

      fetchMicrosites(
        partner,
        organisationTypeName,
        interestName,
        null,
        null,
        size,
        debouncedSearchText,
        af,
        gl,
        ms,
        tz
      );
    }
    if (value == "subsector") {
      // setSubsectorId(null);
      dispatch(setSubSector(""))
      fetchMicrosites(
        partner,
        organisationTypeName,
        interestName,
        sectorId,
        null,
        size,
        debouncedSearchText,
        af,
        gl,
        ms,
        tz
      );
    }
    if (value == "size") {
      setSize(null);
      dispatch(localStorageSetSize(""))
      fetchMicrosites(
        partner,
        organisationTypeName,
        interestName,
        sectorId,
        subsectorId,
        null,
        debouncedSearchText,
        af,
        gl,
        ms,
        tz
      );
    }
    if (value == "searchName") {
      setSearchName(null);
      dispatch(updateSearchName(''))
      fetchMicrosites(
        partner,
        organisationTypeName,
        interestName,
        sectorId,
        subsectorId,
        size,
        null,
        af,
        gl,
        ms,
        tz
      );
    }
    setUpdateFilterData(!updateFilterData);
  };

  const FindSectorName = (id) => {
    let response = "";
    getSector.map((data) => {
      if (id === data.id) {
        response = data.name;
      }
    });
    return response;
  };

  const getSubSector = async (sectorId) => {
    if (!partnerId) return; //
    try {
      setLoading(true);
      const response = await getRequest(userapiservice.getSubSectors(partnerId), {}, false);

      setSubSectors(response);
      setLoading(false);
    } catch (error) {
      toast.error(<ToastComponent type={'Error'} message={error?.error || error?.message || 'Sorry, Something went wrong'} />)
      setLoading(false);
    }
  };

  const getSubSectorName = async (sectorId) => {
    // if (!partnerId) return
    if (!sectorId) return;
    try {
      setLoading(true);
      const response = await getRequest(userapiservice.getSubSectorsForFilter(sectorId));

      setSubSectors(response);
      dispatch(setSubSectorResponse(response))
      setLoading(false);
    } catch (error) {
      toast.error(<ToastComponent type={'Error'} message={error?.error || error?.message || 'Sorry, Something went wrong'} />)
      setLoading(false);
    }
  };

  const FindSubSectorName = (id) => {
    let response = "";

    subSectors?.map((data) => {
      if (id === data.id) {
        response = data.name;
      }
    });

    return response;
  };

  const setFilterHandler = (
    list,
    organisationTypeName,
    interestName,
    sectorId,
    subSectorIds,
    size
  ) => {
    setOrganisationTypeName(organisationTypeName);
    setinterestName(interestName);
    // setSectorId(sectorId);
    dispatch(setSector(sectorId))
    // setSubsectorId(subSectorIds);
    dispatch(setSubSector(subSectorIds))
    setSize(size);
    setMicrosites(list);
  };
  const removeBookmark = async (id, name) => {
    try {
      const response = await deleteRequest(
        userapiservice.removeBookmark(id, phoneNumber)
      );

      if (response) {
        getBookmark();
        toast.success(<ToastComponent type={'Success'} message={`${name} removed from favorites`} />)
      }
    } catch (error) {
      toast.error(<ToastComponent type={'Error'} message={error?.error || error?.message || 'Sorry, Something went wrong'} />)
    }
  };

  const closeModalOfProfile = () => {
    setProfileOpen(false);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
    setVideoUrl("");
  };



  const PlayVideoHandler = (url, mediaType) => {
    setmediatype(mediaType);
    setVideoUrl(url);
    setIsModalOpen(true);
  };

  useEffect(() => {
    // getSubSector(sectorId);
    getSubSectorName(sectorId);
    dispatch(setPage("home"))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    // getSubSector(sectorId);
    getSubSectorName(sectorId);
    dispatch(setPage("home"))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sectorId]);

  const handleAF = () => {
    if (!boolaf) {
      setAf("A-F");
      setBoolAf(true);
    } else {
      setAf("");
      setBoolAf(false);
    }
  };

  const handleGL = () => {
    if (!boolgl) {
      setGl("G-L");
      setBoolGl(true);
    } else {
      setGl("");
      setBoolGl(false);
    }
  };

  const handleMS = () => {
    if (!boolms) {
      setMs("M-S");
      setBoolMs(true);
    } else {
      setMs("");
      setBoolMs(false);
    }
  };

  const handleTZ = () => {
    if (!booltz) {
      setTz("T-Z");
      setBoolTz(true);
    } else {
      setTz("");
      setBoolTz(false);
    }
  };

  const extractSynthesiaId = (url) => {
    const match = url.match(/[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}/);
    return match ? match[0] : null;
  };

  useEffect(() => {
  if (loading || loadingForOrgDirData) return;

  const container = document.querySelector(".list-container");
  const sentinel = sentinelRef.current;

  if (!container || !sentinel) {
    // container data not ready yet
    return;
  }

  const observer = new IntersectionObserver(
    ([entry]) => {

      if (
        entry.isIntersecting &&
        !loadingForOrgDirData &&
        hasMoreOrgDir
      ) {
        setOrgDirPageNumber((p) => p + 1);
      }
    },
    {
      root: container,
      rootMargin: "200px",
      threshold: 0,
    }
  );

  observer.observe(sentinel);

  return () => observer.disconnect();
}, [loading, loadingForOrgDirData, totalData]);

  const BackButtonClick = () => {
    navigate("/");
  };

//   useEffect(() => {
//   onSearchClick(debouncedSearchText);
// }, [debouncedSearchText, partner]);

  const onSearchClick = async (searchText) => {
    if(!partner) return
    try {
      setLoading(true)
      setLoader(true);
      const encodedSearchText = encodeURIComponent(searchText || '');
      
      const response = await getRequest(
        userapiservice.filterMicrosites(partner, "", "", "", "", "", encodedSearchText)
      );

      setMicrosites(response?.result);
      setAllowSetView(true);
    } catch (error) {
      toast.error(<ToastComponent type={'Error'} message={error?.error || error?.message || 'Sorry, Something went wrong'} />)
      console.log("error", error);
    } finally {
      setLoading(false)
      setLoader(false);
    }
  };

  return (
    <div className="microsites-container">
      <div className="search-and-filter-wrapper">
        <div className="arrow-container">
          <div
            style={{ cursor: "pointer" }}
            onClick={() => {
              BackButtonClick();
            }}
          >
            <Back />
          </div>
          <span className="title">Browse Organisations</span>
        </div>

        <div className="search-and-filter-container">
          <div
            style={{ cursor: "pointer" }}
            onClick={() => {
              if (accessToken) {
                setFavMicroSites(!favMicroSites);
              } else {
                setShowModal(true)
              }
            }}
          >
            <img
              src={favMicroSites ? favoriteActive : favorite}
              className="fav-icon"
            />
          </div>
          <div className="title-bar-search-wrapper" >
            <Input onChange={(e) => {
              setSearchText(e?.target?.value)
              // onSearchClick(e?.target?.value);
            }}
              value={searchText}
              placeholder="Search for Businesses"
              className="h-100 w-100"
              maxLength={inputFieldCharLimit}
              prefix={

                <SearchZoomActive customClassName="search-icon-landing-page" />
              }
              suffix={

                <span className="align-items-center d-flex gap-1">
                  {searchText?.length > 0 && <button
                    onClick={() => {
                      setSearchText('');
                      // onSearchClick('');

                    }

                    }
                    className="button-wrapper  ">
                    <CloseActive customClassName="close-button" />
                  </button>}

                  <Filter
                    debouncedSearchText={debouncedSearchText}
                    masterDataIds = {masterDataIds}
                    setData={setFilterHandler}
                    pageType="Homepage"
                    updateFilterData={updateFilterData}

                    selectedOrganisationType={selectedOrganisationType}
                    currentOrganisationType={selectedOrganisationType}
                    setSelectedOrganisationType={setSelectedOrganisationType}

                    setOrganisationNameById={setOrganisationNameById}

                    selectedInterest={selectedInterest}
                    setSelectedInterest={setSelectedInterest}

                  ></Filter>
                </span>

              }
            />
          </div>
          <div className="filter-container">
            <div>
              {!boolaf ? (
                <Button
                  id="A-F-btn"
                  className="alpha-filter-btn alpha-filter"
                  style={{ backgroundColor: "rgba(198, 164, 230, 0.7)" }}
                  onClick={handleAF}
                >
                  <span style={{ color: "white" }}>A-F</span>
                </Button>
              ) : (
                <Button
                  id="A-F-btn"
                  className="alpha-filter-btn alpha-filter"
                  style={{
                    backgroundColor: "rgba(198, 164, 230, 0.7)",
                    border: "1.5px solid #B771F9",
                    WebkitTransition: "all 200ms ease-in",
                    msTransition: "all 200ms ease-in",
                    MozTransition: "all 200ms ease-in",
                    transition: "all 200ms ease-in",
                    WebkitTransform: "scale(1.15)",
                    msTransform: "scale(1.15)",
                    MozTransform: "scale(1.15)",
                    transform: "scale(1.15)",
                    boxShadow: "rgb(38, 57, 77) 0px 20px 30px -10px",
                  }}

                  onClick={handleAF}
                >
                  <span style={{ color: "#fff", fontWeight: "bold" }}>A-F</span>
                </Button>
              )}
              {!boolgl ? (
                <Button
                  id="G-L-btn"
                  type="primary"
                  className="alpha-filter-btn alpha-filter"
                  style={{ backgroundColor: "rgba(242, 119, 148, 0.7)" }}
                  onClick={handleGL}
                >
                  <span style={{ color: "white" }}>G-L</span>
                </Button>
              ) : (
                <Button
                  id="G-L-btn"
                  className="alpha-filter-btn alpha-filter"
                  style={{
                    backgroundColor: "rgba(242, 119, 148, 0.7)",
                    border: "1.5px solid #FE3464",
                    WebkitTransition: "all 200ms ease-in",
                    msTransition: "all 200ms ease-in",
                    MozTransition: "all 200ms ease-in",
                    transition: "all 200ms ease-in",
                    WebkitTransform: "scale(1.15)",
                    msTransform: "scale(1.15)",
                    MozTransform: "scale(1.15)",
                    transform: "scale(1.15)",
                    boxShadow: "#FE3464 0px 20px 30px -10px",
                  }}
                  onClick={handleGL}
                >
                  <span style={{ color: "#fff", fontWeight: "bold" }}>G-L</span>
                </Button>
              )}
              {!boolms ? (
                <Button
                  id="M-S-btn"
                  type="primary"
                  className="alpha-filter-btn alpha-filter"
                  style={{ backgroundColor: "rgba(155, 224, 124, 0.7)" }}
                  onClick={handleMS}
                >
                  <span style={{ color: "white" }}>M-S</span>
                </Button>
              ) : (
                <Button
                  id="M-S-btn"
                  className="alpha-filter-btn alpha-filter"
                  style={{
                    backgroundColor: "rgba(155, 224, 124, 0.7)",

                    border: "1.5px solid #65AD45",
                    WebkitTransition: "all 200ms ease-in",
                    msTransition: "all 200ms ease-in",
                    MozTransition: "all 200ms ease-in",
                    transition: "all 200ms ease-in",
                    WebkitTransform: "scale(1.15)",
                    msTransform: "scale(1.15)",
                    MozTransform: "scale(1.15)",
                    transform: "scale(1.15)",
                    boxShadow: "#65AD45 0px 20px 30px -10px",
                  }}
                  onClick={handleMS}
                >
                  <span style={{ color: "#fff", fontWeight: "bold" }}>M-S</span>
                </Button>
              )}
              {!booltz ? (
                <Button
                  id="T-Z-btn"
                  type="primary"
                  className="alpha-filter-btn alpha-filter"
                  style={{ backgroundColor: "rgba(114, 225, 213, 0.7)" }}
                  onClick={handleTZ}
                >
                  <span style={{ color: "white" }}>T-Z</span>
                </Button>
              ) : (
                <Button
                  id="T-Z-btn"
                  className="alpha-filter-btn alpha-filter"
                  style={{
                    backgroundColor: "rgba(114, 225, 213, 0.7)",
                    border: "1.5px solid #1EB8A7",
                    WebkitTransition: "all 200ms ease-in",
                    msTransition: "all 200ms ease-in",
                    MozTransition: "all 200ms ease-in",
                    transition: "all 200ms ease-in",
                    WebkitTransform: "scale(1.15)",
                    msTransform: "scale(1.15)",
                    MozTransform: "scale(1.15)",
                    transform: "scale(1.15)",
                    boxShadow: "#1EB8A7 0px 20px 30px -10px",
                  }}
                  onClick={handleTZ}
                >
                  <span style={{ color: "#fff", fontWeight: "bold" }}>T-Z</span>
                </Button>
              )}

            </div>
            {typeOfDevice !== "laptop" && (
              <img
                onClick={() => {
                  if (activeMicros === "list") {
                    setActiveMicros("view");
                  } else {
                    setActiveMicros("list");
                  }
                }}
                src={activeMicros === "list" ? MapIcon : ListIcon}
                className="toggle-img"
                alt="map"
              />
            )}
          </div>

        </div>
      </div>
      {organisationTypeName ||
        organisationNameById ||
        interestName ||
        sectorId ||
        subsectorId ||
        size ||
        searchName ? (
        <div className="filter-options">
          {organisationTypeName && organisationNameById ? (
            <Tag
              style={{ marginTop: "3px" }}
              closable
              onClose={RemoveHandler.bind(this, "organisationType")}
            >
              {/* // <Tag closable> */}
              {organisationNameById ? organisationNameById : ""}
            </Tag>
          ) : null}
          {interestName ? (
            <Tag
              style={{ marginTop: "3px" }}
              closable
              onClose={RemoveHandler.bind(this, "interest")}
            >
              {/* // <Tag closable> */}
              {interestName === "APPRENTICESHIP"
                ? "Apprenticeships"
                : interestName === "VACANCY"
                  ? "Vacancies"
                  : interestName === "PRODUCT"
                    ? "Products"
                    : interestName === "CONTRACTS"
                      ? "Contracts"
                      : interestName === "SERVICE"
                        ? "Services"
                        : interestName === "WORK_EXPERIENCE"
                          ? "Experiences of work"
                          : interestName === "COURSES"
                            ? "Courses"
                            : ""}
            </Tag>
          ) : null}
          {sectorId ? (
            <Tag
              style={{ marginTop: "3px" }}
              closable
              onClose={RemoveHandler.bind(this, "sector")}
            >
              {FindSectorName(sectorId)}
            </Tag>
          ) : null}
          {subsectorId ? (
            <Tag
              style={{ marginTop: "3px" }}
              closable
              onClose={RemoveHandler.bind(this, "subsector")}
            >
              {FindSubSectorName(subsectorId)}
            </Tag>
          ) : null}
          {size ? (
            <Tag
              style={{ marginTop: "3px" }}
              closable
              onClose={RemoveHandler.bind(this, "size")}
            >
              {size === "MICRO"
                ? "Micro 0-9"
                : size === "SMALL"
                  ? "Small 10-49"
                  : size === "MEDIUM"
                    ? "Medium 50-249"
                    : size === "LARGE"
                      ? "Large 250+"
                      : ""}
            </Tag>
          ) : null}
          {searchName ? (
            <Tag
              style={{ marginTop: "3px" }}
              closable
              onClose={RemoveHandler.bind(this, "searchName")}
            >
              {searchName}
            </Tag>
          ) : null}
        </div>
      ) : (
        ""
      )}

      <div id="list" className="list-and-view-container">
        {activeMicros === "view" && (
          <div
            className="view-container"
            style={{ width: activeMicros === "view" && "100%" }}
          >
            <div className="arrows-wrapper">
              <div></div>
              <div className="arrows-container">
                {typeOfDevice === "laptop" ? (
                  <>
                    <div
                      onClick={() => {
                        setActiveMicros("both");
                      }}
                      className="arrows"
                    >
                      &larr;
                    </div>
                    <div
                      onClick={() => {
                        setActiveMicros("view");
                      }}
                      className="arrows"
                    >
                      &rarr;
                    </div>
                  </>
                ) : typeOfDevice === "tab" ? (
                  <img
                    onClick={() => {
                      setActiveMicros("list");
                    }}
                    src={ListIcon}
                    className="responsive-view-img"
                    alt="map"
                  />
                ) : (
                  ""
                )}
              </div>
            </div>
            <MapView
              businessCardHeight={mapHeight * 0.6}
              id="mav-view"
              className="ant-map"
              microSitesData={microsites}
              expandMap={false}
              allowSetView={allowSetView}
              selectedData={(val) => {
                setSelectedMicroSite(val);
              }}
              disableSetView={() => {
                setAllowSetView(false);
              }}
              orgDirectoryData = {orgDirectoryData}
              cardData={selectedMicroSite}
              cardState={selectedMicroSite ? true : false}
              previewCardState={
                Object.keys(selectedMicroSite || {})?.length ? true : false
              }
            />
          </div>
        )}

        {activeMicros === "both" || activeMicros === "list" ? (
          <div
            className="list-container"
            style={{ width: activeMicros === "list" && "100%" }}
          >
            <div className="arrows-wrapper">
              <div></div>
              <div className="arrows-container">
                {typeOfDevice === "laptop" ? (
                  <>
                    <div
                      onClick={() => {
                        setActiveMicros("both");
                      }}
                      className="arrows"
                    >
                      &larr;
                    </div>
                    <div
                      onClick={() => {
                        setActiveMicros("list");
                      }}
                      className="arrows"
                    >
                      &rarr;
                    </div>
                  </>
                ) : typeOfDevice === "tab" ? (
                  <img
                    onClick={() => {
                      setActiveMicros("list");
                    }}
                    src={ListIcon}
                    className="responsive-view-img"
                    alt="map"
                  />
                ) : (
                  ""
                )}
              </div>
            </div>

            {((loading || loadingForOrgDirData) && orgDirPageNumber===0) ? (
              <Loader />
            ) : (
              <>
                <motion.div
                  className={
                    activeMicros === "list"
                      ? totalData && totalData.length === 0
                        ? "empty-micros"
                        : "list-card-container list-grid"
                      : totalData && totalData.length === 0
                        ? "empty-micros"
                        : "list-card-container"
                  }
                >
                  {totalData && totalData.length > 0 ? (
                    totalData.map((microsite) => {
                      if(microsite?.isActual){
                        return <motion.div
                        initial={{ opacity: 0, scale: 0.5 }}
                        animate={{ opacity: 1, scale: 1 }}
                        transition={{
                          duration: 0.8,
                          delay: 0.5,
                          ease: [0, 0.71, 0.2, 1.01],
                        }}
                        // onClick={() => handleCardClick(microsite)}
                        className="motion-wrapper"
                      >
                        <Card
                          style={{
                            border:
                              selectedMicroSite?.micrositeLogo ===
                                microsite?.micrositeLogo
                                ? "1px solid red"
                                : "",
                          }}
                          className="card-wrapper"
                        >
                          <div className="card-container">
                            <div className="card-image-container">
                              {microsite.carouselLink?.mediaType ===
                                "SOCIAL_MEDIA" &&
                                microsite.carouselLink?.url ? (
                                <>
                                  {(() => {
                                    const videoID = getYouTubeVideoId(microsite.carouselLink?.url);
                                    if (!videoID) return null;

                                    return (
                                      <div
                                        className="media-image-container media1 youtube1"
                                        style={{
                                          objectFit: "contain",
                                          borderRadius: "8px",
                                        }}
                                        onClick={() =>
                                          PlayVideoHandler(
                                            `https://www.youtube.com/embed/${videoID}?autoplay=1&rel=0`,
                                            microsite.carouselLink?.mediaType
                                          )
                                        }
                                      >
                                        <img
                                          src={`https://img.youtube.com/vi/${videoID}/hqdefault.jpg`}
                                          alt=""
                                          className="video-preview-image image-preview"

                                        />
                                        {bookmarkData.filter(
                                          (item) => item.id === microsite.id
                                        ).length > 0 ? (
                                          <img
                                            className="bookMarked"
                                            src={favoriteActive}
                                            alt="bookmark"
                                          />
                                        ) : null}
                                        <img
                                          className="play-button"
                                          src={youTubePlayButton}
                                        />
                                      </div>
                                    );
                                  })()}
                                </>
                              ) : microsite.carouselLink?.mediaType ===
                                "VIMEO_MEDIA" &&
                                microsite.carouselLink?.url ? (
                                <div
                                  className="media-image-container media vimeo youtube"
                                  onClick={() => {
                                    PlayVideoHandler(
                                      microsite.carouselLink?.url,
                                      microsite.carouselLink?.mediaType
                                    );
                                  }}
                                >
                                  <img
                                    src={`https://vumbnail.com/${microsite.carouselLink?.url?.split("/")[4]
                                      }.jpg`}
                                    className="video-preview-image image-preview"
                                  />
                                  {bookmarkData.filter(
                                    (item) => item.id === microsite.id
                                  ).length > 0 ? (
                                    <img
                                      className="bookMarked"
                                      src={favoriteActive}
                                      alt="bookmark"
                                    />
                                  ) : null}
                                  <img
                                    className="play-button"
                                    src={youTubePlayButton}
                                  />
                                </div>
                              ) : microsite.carouselLink?.mediaType ===
                                "SYNTHESIA_MEDIA" && microsite.carouselLink?.url ? (
                                (() => {
                                  const videoId = extractSynthesiaId(microsite.carouselLink.url);
                                  if (!videoId) return null;

                                  return (
                                    <div
                                      // className="media vimeo youtube"
                                      className="media-image-container media1 youtube1"

                                      onClick={() =>
                                        PlayVideoHandler(
                                          `https://share.synthesia.io/embeds/videos/${videoId}?autoplay=1`,
                                          microsite.carouselLink.mediaType
                                        )
                                      }
                                    >
                                      {/* <div style={{ position: "relative" }}> */}
                                      <img
                                        src={microsite?.carouselLink?.thumbnailUrl || SynthesiaImage}
                                        alt="Synthesia Video"
                                        className="video-preview-image image-preview"
                                      />
                                      {bookmarkData.filter(
                                        (item) => item.id === microsite.id
                                      ).length > 0 ? (
                                        <img
                                          className="bookMarked"
                                          src={favoriteActive}
                                          alt="bookmark"
                                        />
                                      ) : null}
                                      <img
                                        className="play-button"
                                        src={ytPlayBtn}
                                        alt="Play Button"
                                      />
                                      {/* </div> */}
                                    </div>
                                  );

                                })()
                              ) : (
                                <div className="media">
                                  <div className="slider-Img">
                                    <img
                                      src={microsite.carouselLink?.url}
                                      alt=""
                                      className="home-preview-img"
                                    />
                                  </div>
                                  {bookmarkData.filter(
                                    (item) => item.id === microsite.id
                                  ).length > 0 ? (
                                    <img
                                      className="bookMarked"
                                      src={favoriteActive}
                                      alt="bookmark"
                                    />
                                  ) : null}
                                </div>
                              )}
                            </div>
                            <div
                              className="card-description-container"
                              onClick={() => {
                                handleCardClick(microsite);

                                if (
                                  localDataAccessToken
                                ) {
                                  setOpenMicrosite(true);
                                }
                                setProfileOpen(true);
                              }}
                            >
                              <div className="micro-share-and-logo-container">
                                <div className="logo-and-share-wrapper">
                                  <div
                                    className="logo-container"
                                  >
                                    <img
                                      src={microsite.micrositeLogo}
                                      alt={microsite.name}
                                      className="microsite-preview-image"
                                    />
                                  </div>
                                </div>
                                <div className="kebab-menu">
                                  <Dropdown
                                    trigger={["click"]}
                                    placement="bottomRight"
                                    overlay={
                                      <div
                                        className="microsite-dropdown"
                                        style={{
                                          border: "1px solid #f0f0f0",
                                          borderRadius: "4px",
                                          backgroundColor: "#fff",
                                          minWidth: "170px",
                                        }}
                                      >
                                        <div
                                          style={{
                                            padding: "10px",
                                            borderBottom: "1px solid #f0f0f0",
                                            cursor: "pointer",
                                          }}
                                        >
                                          <div onClick={(e) => { e.stopPropagation(); }} className="share-dropdown">
                                            <RWebShare
                                              data={{
                                                url: `${baseUrl}/microsite/${microsite.name.replace(
                                                  / /g,
                                                  "_"
                                                )}?partnerId=${partnerData.id}`,
                                              }}
                                            >
                                              <div>
                                                <img
                                                  src={shareIcon}
                                                  alt="share"
                                                />
                                                <span
                                                  style={{
                                                    marginLeft: "5px",
                                                  }}
                                                >
                                                  Share
                                                </span>
                                              </div>
                                            </RWebShare>
                                          </div>
                                        </div>
                                        {phoneNumber && accessToken ? (
                                          bookmarkData.filter(
                                            (item) => item.id === microsite.id
                                          ).length > 0 ? (
                                            <div
                                              style={{
                                                padding: "10px",
                                                cursor: "pointer",
                                                display: "flex",
                                              }}
                                              onClick={(e) => {
                                                removeBookmark(
                                                  microsite.id,
                                                  microsite.name
                                                );
                                                e.stopPropagation();
                                              }}
                                            >
                                              {/* <img src={favoriteActive} alt="share" /> */}
                                              <img
                                                width={18}
                                                src={favoriteActive}
                                                alt="share"
                                              />

                                              <span
                                                style={{
                                                  marginLeft: "5px",
                                                }}
                                              >
                                                Remove from Favorite
                                              </span>
                                            </div>
                                          ) : (
                                            <div
                                              className="fav-wrapper"
                                              style={{
                                                padding: "10px",
                                                cursor: "pointer",
                                                display: "flex",
                                              }}
                                              onClick={(e) => {
                                                handleBookmark(
                                                  microsite.id,
                                                  microsite.name
                                                );
                                                e.stopPropagation();
                                              }}
                                            >
                                              <img
                                                width={18}
                                                src={favorite}
                                                className="save-as-fav"
                                                alt="share"
                                                style={{
                                                  marginRight: "5px",
                                                }}
                                              />
                                              Save as Favorite
                                            </div>
                                          )
                                        ) : (
                                          <div
                                            className="save-as-fav"
                                            style={{
                                              padding: "10px",
                                              cursor: "not-allowed",
                                              opacity: 0.5,
                                            }}
                                          >
                                            <img
                                              width={18}
                                              className="save-as-fav-img"
                                              src={favorite}
                                              alt="share"
                                            />

                                            <span
                                              style={{ marginLeft: "5px" }}
                                              onClick={(e) => {

                                                toast.error(<ToastComponent type={'Error'} message={'Please login to access Favorites'} />)

                                                e.stopPropagation();
                                              }}
                                            >
                                              Save as Favorite
                                            </span>
                                          </div>
                                        )}
                                      </div>
                                    }
                                  >
                                    <img
                                      onClick={(e) => e.stopPropagation()}
                                      className="share-icon"
                                      src={share}
                                      alt="Options"
                                      style={{ cursor: "pointer" }}
                                    />
                                  </Dropdown>
                                </div>
                              </div>

                              <div className="sector-text-container">
                                <span className="microsite-details-text">
                                  {microsite.businessDescription}
                                </span>
                              </div>
                            </div>
                          </div>
                        </Card>
                      </motion.div>
                      }
                      else{
                        return (
                          <motion.div
                        initial={{ opacity: 0, scale: 0.5 }}
                        animate={{ opacity: 1, scale: 1 }}
                        transition={{
                          duration: 0.8,
                          delay: 0.5,
                          ease: [0, 0.71, 0.2, 1.01],
                        }}
                        // onClick={() => handleCardClick(microsite)}
                        className="motion-wrapper"
                      >
                        <Card
                          style={{
                            border: '1px solid black'
                          }}
                          className="card-wrapper"
                        >
                          <div className="card-container org-directory-card">
                            <div className="d-flex flex-column text-center">
                              <div className="name">{microsite?.name}</div>
                              <div>{microsite?.address}</div>

                              {microsite?.phoneNumber && <div>
                                <span>Phone number: </span>
                                <span>{microsite?.phoneNumber || '--'}</span>
                              </div>}
                              {microsite?.email && <div>
                                <span>Email: </span>
                                <span>{microsite?.email || '--'}</span>
                              </div>}
                              <div>
                              {microsite?.website &&  <>
                              <span>Website: </span>
                              <a
                                  title={microsite?.website}
                                  href={microsite?.website}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  style={{ color: "#2563eb", textDecoration: "underline" }}
                                >
                                  {microsite.website?.slice(0,70)}{microsite?.website?.length > 70 ? '...' : ''}
                                </a>
                                </>}
                            </div>
                            </div>
                          </div>
                        </Card>
                      </motion.div>
                        )
                      }
})
                  ) : (
                    <div className="no-micros">
                      {totalData && totalData.length === 0 && (
                        <div>
                          "Sorry there are no organisations at present for this
                          search so try removing filters"
                        </div>
                      )}
                    </div>
                  )}
                  {hasMoreOrgDir && !dontShowOrgData && <div ref={sentinelRef}>
                    <Loader />
                  </div>}
                </motion.div>
                
              </>
            )}
            
          </div>
        ) : (
          ""
        )}

        {activeMicros === "both" ? (
          <div className="view-container">
            <div className="arrows-wrapper">
              <div></div>
              <div className="arrows-container">
                <div
                  onClick={() => {
                    setActiveMicros("both");
                  }}
                  className="arrows"
                >
                  &larr;
                </div>
                <div
                  onClick={() => {
                    setActiveMicros("view");
                  }}
                  className="arrows"
                >
                  &rarr;
                </div>
              </div>
            </div>
            <MapView
              id="mav-view"
              businessCardHeight={mapHeight * 0.6}
              disableSetView={() => {
                setAllowSetView(false);
              }}
              microSitesData={microsites}
              orgDirectoryData = {orgDirectoryData}
              selectedData={(val) => {
                setSelectedMicroSite(val);
              }}
              cardData={selectedMicroSite}
              previewCardState={
                Object.keys(selectedMicroSite || {})?.length ? true : false
              }
              allowSetView={allowSetView}
            />
          </div>
        ) : (
          ""
        )}
      </div>


      {isModalOpen ? (
        <ModalPlayer
          closeModal={handleCancel}
          mediaLink={videoUrl}
          mediaType={mediatype}
        />
      ) : (
        ""
      )}

      {showModal &&
        <Modal
          open={showModal}
          onCancel={() => setShowModal(false)}
          footer={false}

        >
          <div>
            <div
              className="info-container"
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                flexGrow: "1",
                justifyContent: "center",
              }}
            >
              <img src={lockIcon} alt="Partner Logo" />
              <span className="text-to-contact-info">
                Please login to access Favorites
              </span>
              <a
                style={{ color: "#3067AE" }}
                className="text-to-contact-info"
                onClick={() =>
                  navigate("/login", { state: { id, page: "microsite" } })
                }
              >
                Login

              </a>
            </div>
          </div>
        </Modal>
      }

    </div>
  );
}